import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import fbIcon from '@/assets/images/fb-logo.svg';
import twIcon from '@/assets/images/tw-logo.svg';
import {
  SnsLinksSection,
  SnsLink,
  IconWrapper,
  Icon,
  SnsLinkWrapper,
  Linker,
} from '@/components/SocialShare/SocialShare.style';
import Placeholder from '@/components/Placeholder';

class SocialShare extends PureComponent {
  render() {
    const { siteCopySnsLink, shareUrl, twitterText } = this.props;
    const defaultTweetText = twitterText
      ? `&text=${encodeURIComponent(twitterText.replace(/#/gi, '').replace(/\n/gi, ''))}`
      : '';

    return (
      <SnsLinksSection>
        <SnsLink className="fbIcon">
          <SnsLinkWrapper>
            {siteCopySnsLink && _.get(siteCopySnsLink, 'facebook_share') ? (
              <Linker
                id="fb-share"
                rel="noopener noreferrer"
                target="_blank"
                href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`}
              >
                <IconWrapper>
                  <Icon src={fbIcon} />
                </IconWrapper>
                {siteCopySnsLink.facebook_share}
              </Linker>
            ) : (
              <Placeholder w="50px" h="10px" />
            )}
          </SnsLinkWrapper>
        </SnsLink>
        <SnsLink className="twIcon">
          <SnsLinkWrapper>
            {siteCopySnsLink && _.get(siteCopySnsLink, 'twitter_share') ? (
              <Linker
                rel="noopener noreferrer"
                target="_blank"
                href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}${defaultTweetText}`}
              >
                <IconWrapper>
                  <Icon src={twIcon} />
                </IconWrapper>
                {siteCopySnsLink.twitter_share}
              </Linker>
            ) : (
              <Placeholder w="50px" h="10px" />
            )}
          </SnsLinkWrapper>
        </SnsLink>
      </SnsLinksSection>
    );
  }
}

SocialShare.defaultProps = {
  siteCopySnsLink: null,
  shareUrl: null,
  twitterText: '',
};

SocialShare.propTypes = {
  siteCopySnsLink: PropTypes.shape({}),
  shareUrl: PropTypes.string,
  twitterText: PropTypes.string,
};

export default SocialShare;



// WEBPACK FOOTER //
// ./src/components/SocialShare/index.js